import React, { useState } from 'react';
import { Stack, Divider, Typography, List } from '@mui/material';
import { CheckboxInput, NextPrevButton } from 'Components';
import { useDictionary, useImposter, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface StatementFormProps {
  formData: any;
  formName: string;
  setFormData: (data: any) => void;
  handleSubmit: () => void;
  handlePrevStep: () => void;
}

export const StatementForm: React.FC<StatementFormProps> = ({
  formData,
  formName,
  setFormData,
  handleSubmit,
  handlePrevStep,
}) => {
  const [error, setError] = useState(false);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const isDesktop = useIsDesktop();
  const { authenticatedUser, fakeUser } = useImposter();

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, isApproved: e.target.checked });
    setError(!e.target.checked);
  };

  const submitForm = () => {
    if (!formData.isApproved) {
      setError(true);
    } else {
      setError(false);
      handleSubmit();
    }
  };

  const items = [
    dictionary.statement.i1,
    dictionary.statement.i2,
    dictionary.statement.i3,
    dictionary.statement.i4,
  ];

  const userDetails = {
    firstName: fakeUser.firstName || authenticatedUser.firstName || '',
    lastName: fakeUser.lastName || authenticatedUser.lastName || '',
    id: fakeUser.israeliId || authenticatedUser.israeliId || '',
  };

  return (
    <Stack spacing={2} maxWidth={'800px'} margin={'0 auto'}>
      <Typography component={'h2'} variant='h3' textAlign={'center'}>
        {dictionary.statement.title}
      </Typography>
      <Typography
        component={'h2'}
        variant={isDesktop ? 'h6' : 'body3'}
        fontWeight={'600'}
        textAlign={isDesktop ? undefined : 'center'}
      >
        {dictionary.statement.subtitle(formName)}
      </Typography>
      <Typography variant='body2'>{dictionary.statement.iStatement}</Typography>
      <List
        component={'ol'}
        sx={{
          listStyle: 'decimal',
          pl: '20px',
          mt: '0!important',
          maxWidth: isDesktop ? '80%' : '100%',
        }}
      >
        {items.map((item) => (
          <Typography
            variant='body5'
            component={'li'}
            mb={1}
            fontWeight={'400 !important'}
            key={item}
          >
            {item}
          </Typography>
        ))}
      </List>
      <Divider
        aria-hidden='true'
        sx={{ m: '18px 0', width: '100%', borderColor: 'primary.shade_200' }}
      />
      <CheckboxInput
        checked={formData.isApproved}
        onChange={handleCheckboxChange}
        label={dictionary.statement.checkboxLabel(
          userDetails.firstName,
          userDetails.lastName,
          userDetails.id
        )}
        textSx={{
          p: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
        containerStyle={{ pb: '24px ' }}
        isError={error}
        errorMsg={dictionary.statement.checkboxError}
      />
      <Stack direction='row' justifyContent='space-around' spacing={2}>
        <NextPrevButton
          callback={handlePrevStep}
          text={dictionary.back}
          style={
            isDesktop
              ? undefined
              : {
                  button: { height: '36px', maxWidth: '110px' },
                  text: { fontSize: '16px', fontWeight: '600' },
                }
          }
        />
        <NextPrevButton
          callback={submitForm}
          text={dictionary.submit}
          style={
            isDesktop
              ? undefined
              : {
                  button: { height: '36px' },
                  text: { fontSize: '16px', fontWeight: '600' },
                }
          }
          isBlue
          isNext
        />
      </Stack>
    </Stack>
  );
};
